import axios from 'axios';

import { Twig, Pagination } from '../types';
import { API_URL } from '../config/env';

import { transformTwig, transformProductOption } from './helpers';
import { track } from './mixpanelService';

export async function getTwigById(id: string): Promise<Twig> {
  const {
    data: { data },
  } = await axios.get(`${API_URL}/twigs/${id}`);
  return transformTwig(data);
}

export async function getTrendingTwigs(): Promise<Twig[]> {
  const {
    data: { data },
  } = await axios.get(
    `${API_URL}/twigs/discover_for_you?latitude=55.2708&longitude=25.2048&limit=6`,
  );

  return data.map(transformTwig);
}

export async function addTwigToTodo(twigID: string) {
  const {
    data: { data },
  } = await axios.post(`${API_URL}/todo`, {
    twig_id: twigID,
    status: 'done',
  });

  return data;
}

export async function deleteTodoByTwigID(twigID: string) {
  const {
    data: { data },
  } = await axios.delete(`${API_URL}/todo/by_twig/${twigID}`);
  return data;
}

export async function getTwigsByUserID(
  userID: string,
  page: number = 1,
  limit: number = 10,
): Promise<{
  twigs: Twig[];
  pagination: Pagination;
}> {
  const {
    data: { data, paginator },
  } = await axios.get(
    `${API_URL}/twigs/all?user_id=${userID}&page=${page}&limit=${limit}`,
  );
  return {
    twigs: data.map(transformTwig),
    pagination: {
      totalCount: paginator.total_count,
      totalPages: paginator.total_pages,
    },
  };
}

export async function getTwigsByBusinessID(
  businessID: string,
  page: number = 1,
  limit: number = 10,
): Promise<{
  twigs: Twig[];
  pagination: Pagination;
}> {
  const {
    data: { data, paginator },
  } = await axios.get(
    `${API_URL}/twigs/all?business_id=${businessID}&page=${page}&limit=${limit}`,
  );
  // const { data, paginator } = allTwigs;

  return {
    twigs: data.map(transformTwig),
    pagination: {
      totalCount: paginator.total_count,
      totalPages: paginator.total_pages,
    },
  };
}

export async function getTwigsByProductID(
  productId: string,
  page: number = 1,
  limit: number = 10,
): Promise<{
  twigs: Twig[];
  pagination: Pagination;
}> {
  const {
    data: { data, paginator },
  } = await axios.get(
    `${API_URL}/twigs/all?product_ids[]=${productId}&page=${page}&limit=${limit}`,
  );
  // const { data, paginator } = allTwigs;

  return {
    twigs: data.map(transformTwig),
    pagination: {
      totalCount: paginator.total_count,
      totalPages: paginator.total_pages,
    },
  };
}

export async function listOptionTwigs(
  parametar: string
) {
  const { data: { data, data_2 }, } = await axios.get(`${API_URL}/twigs/filters_count?${parametar}`)
  return {
    data: data.map(transformProductOption),
    data_2: data_2

  }
}

export async function listTwigs(page: number = 1,limit: number = 10,parametar: string = ""): Promise<{twigs: Twig[];pagination: Pagination;}> {
  const {
    data: { data, paginator },
  } = await axios.get(`${API_URL}/twigs/all?page=${page}&limit=${limit}&${parametar} "&latitude=25.2&longitude=55.27"`);
  if (page == 1 && parametar != "")
    track("apply_filter")
  // const { data, paginator } = allTwigs;
  return {
    twigs: data.map(transformTwig),
    pagination: {
      totalCount: paginator.total_count,
      totalPages: paginator.total_pages,
    },
  };
}

export async function listFollowingTwigs(
  page: number = 1,
  limit: number = 10,
): Promise<{
  twigs: Twig[];
  pagination: Pagination;
}> {
  const {
    data: { data, paginator },
  } = await axios.get(`${API_URL}/twigs/my_twigs?page=${page}&limit=${limit}`);
  return {
    twigs: data.map(transformTwig),
    pagination: {
      totalCount: paginator.total_count,
      totalPages: paginator.total_pages,
    },
  };
}





export async function listOffers(
  page: number = 1,
  limit: number = 10,
): Promise<{
  twigs: Twig[];
  pagination: Pagination;
}> {
  const {
    data: { data, paginator },
  } = await axios.get(`${API_URL}/twigs/offers?page=${page}&limit=${limit}`);
  return {
    twigs: data.map(transformTwig),
    pagination: {
      totalCount: paginator.total_count,
      totalPages: paginator.total_pages,
    },
  };
}


export async function explorerlistTwigs(
  page: number = 1,
  limit: number = 10,
  parametar: string = ""
): Promise<{
  twigs: Twig[];
  pagination: Pagination;
}> {
  const {
    data: { data, paginator },
  } = await axios.get(`${API_URL}/twigs/discover_home?latitude=25.276987&longitude=55.296249&page=${page}&limit=${limit}&${parametar}`);
  // const { data, paginator } = allTwigs;
  return {
    twigs: data.map(transformTwig),
    pagination: {
      totalCount: paginator.total_count,
      totalPages: paginator.total_pages,
    },
    // twigs: data.map(transformTwig),
    // pagination: {
    //   totalCount: paginator.total_count,
    //   totalPages: paginator.total_pages,
    // },
  };
}

export async function searchListTwigs(
  page: number = 1,
  limit: number = 10,
  parametar: string
): Promise<{
  twigs: Twig[];
  pagination: Pagination;
}> {
  const {
    data: { data, paginator },
  } = await axios.get(`${API_URL}/twigs/explore${parametar}&page=${page}&limit=${limit}`);
  // const { data, paginator } = allTwigs;
  return {
    twigs: data.map(transformTwig),
    pagination: {
      totalCount: paginator.total_count,
      totalPages: paginator.total_pages,
    },
  };
}
